class ValidationResult
	string	errorMessage
	string	lastValidValue

class DropdownState
	string[]	filteredOptions
	bool	showDropdown
	int	selectedIndex	= -1
	float	lastBlurTime

class ValidationState
	private string[string]	errorForLabel = {}
	private bool[string]	shouldValidateForLabel = {}
	bool	showErrrorsForEmptyFields = false

	clear
		errorForLabel.clear
		shouldValidateForLabel.clear
		showErrrorsForEmptyFields = false

	set: string label, string errorMessage
		if errorMessage: errorForLabel[label] = errorMessage
		else             errorForLabel.remove(label)

	get: string label
		return errorForLabel[label] or ""

	setShouldValidate: string label, bool shouldValidate = true
		this.shouldValidateForLabel[label] = shouldValidate

	shouldValidate: string label
		return shouldValidateForLabel[label] or showErrrorsForEmptyFields

	overrideError: string label, string message = ""
		errorForLabel[label] = message
		shouldValidateForLabel[label] = false
		showErrrorsForEmptyFields = false

	checkForErrorsOrEmptyFields
		showErrrorsForEmptyFields = true
		refresh
		return errorForLabel.length > 0

	errorCount
		return errorForLabel.length

form
	showErrorMessage: string errorMessage
		if errorMessage != ""
			div text:errorMessage, fontSize:12, color:#ef4444, marginBottom:8

	// Renders a label with required asterisk and help tooltip
	drawLabel: string name, bool required, string help
		state bool showHelp = false
		if name != ""
			div display:flex, alignItems:center, gap:8
				html.div text:required and !name.startsWith("<p") ? "{name} (*)" : name, fontSize:14, color:#40465a, fontWeight:500
				if help != "" and help != null
					div position:relative
						img Info width:15 padding:{top:4} onPointerOver: showHelp = true; refresh
							onPointerOut: showHelp = false; refresh
						if showHelp
							div position:absolute, backgroundColor:#2b3145, color:#ffffff
								padding:{top:8 bottom:8 left:12 right:12}, borderRadius:8
								fontSize:12, zIndex:1000, width:200, left:30, top:0
								boxShadow:{offset:{0,4}, blur:8, spread:0, color:#00000020}
								div text:help

	// A html input element with a dropdown list of options
	// Example:
	//     form.dropdown label:"Color", model:selectedColor, options:["Red", "Green", "Blue"]
	dropdown: string label
		      Reference<string> model
			  Dimension width = 100%
		      string[] options
		      bool allowCustomValues = false
		      int minTextLength = 1
		      int maxTextLength = 100
			  void(string value) onChange = null
			  void(string value) onInput = null
			  bool required = false
			  string help = ""
			  ValidationState validationState = {}
		state DropdownState state = {}
		state string lastValidValue = ""
		let readOnly = state.showDropdown == false
		let currentValue = model or ""
		let errorMessage = validationState[label]
		
		column
			drawLabel label, required, help
			div position:relative overflow:visible
				var input = input width:width value:currentValue readOnly
					borderRadius:8 border:{2px solid #d1d5db} padding:{12 40 12 16}
					cursor:readOnly ? pointer : text, fontSize:16, color:#2b3145
					outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				onInput: value =>
					model = value
					let lowercaseValue = value.toLowerCase
					state.filteredOptions.setFilteredList options, condition:.toLowerCase.contains(lowercaseValue)
					state.selectedIndex = value ? 0 : -1
					if onInput != null: onInput(value)
					refresh
				onKeyDown:
					if ev.keyCode == Up and state.selectedIndex > 0
						state.selectedIndex--; ev.preventDefault; refresh
					if ev.keyCode == Down and state.selectedIndex < state.filteredOptions.length - 1
						state.selectedIndex++; ev.preventDefault; refresh
					if ev.keyCode == Enter and state.selectedIndex >= 0
						model = state.filteredOptions[state.selectedIndex]
						state.showDropdown = false
						if onInput != null: onInput(model or "")
						if onChange != null: onChange(model or "")
						refresh
				onFocus:
					state.showDropdown = true
					state.filteredOptions.setList options
					state.selectedIndex = state.filteredOptions.indexOf(model)
					state.lastBlurTime = 0
					refresh
				onBlur:
					if model: validationState.setShouldValidate(label)
					state.showDropdown = false
					state.lastBlurTime = Time.now
					let value = model or ""
					if onChange != null: onChange(model or "")
					refresh
				img OpenDropdown, width:32, padding:{19 8}, cursor:pointer, position:absolute, right:10
				onClick:
					if not state.showDropdown and Time.now - state.lastBlurTime > 200
						state.showDropdown = true
						state.filteredOptions.setList options
						state.selectedIndex = state.filteredOptions.indexOf(model)
						input.focus
					state.lastBlurTime = 0
					refresh
				if state.showDropdown
					div border:{1px solid #e2e8f0} borderRadius:8
						width, position:absolute, backgroundColor:white, zIndex:1000
						margin:{top:4}, boxShadow:{10px 10px 25px #00000010},
						overflowY:auto, maxHeight:400px
						for state.filteredOptions as option
							div text:option padding:{12px 16px} color:#2d3748
							borderLeft:{3px solid i == state.selectedIndex ? primaryColor : transparent}
							backgroundColor:i == state.selectedIndex ? lightColor : white
							cursor:pointer
							styleWhenHovering: {borderLeft:{3px solid primaryColor}, backgroundColor:lightColor}
							onPointerDown:
								model = option
								state.showDropdown = false
								validationState.set(label, "")
								lastValidValue = option
								if onInput != null: onInput(option)
								if onChange != null: onChange(option)
								refresh

			if validationState.shouldValidate(label)
				if not currentValue and required:       validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				                                        validationState[label] = ""
			showErrorMessage validationState[label]
	// Example:
	//     form.text label:"Name", model:userName
	text: string label
		  Reference<string> model
		  Dimension width = 100%
		  int rows = 1
		  int minTextLength = 1
		  int maxTextLength = 100
		  void(string value) onChange = null
		  void(string value) onInput = null
		  bool required = false
		  ValidationState validationState = {}
		  string help = ""
		  bool focusInitially = false
		column width
			drawLabel label, required, help
			string currentValue = model or ""
			input width:100%, value:currentValue, focusInitially, rows
				borderRadius:8 border:{2px solid #d1d5db} padding:{12 16}
				outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				fontSize:16, color:#2b3145
			onInput: value =>
				model = value
				if onInput != null: onInput(value)
				refresh
			onBlur:
				if model: validationState.setShouldValidate(label)
				if onChange != null: onChange(model)
				refresh

			if validationState.shouldValidate(label)
				if not currentValue and required:       validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if currentValue.length < minTextLength and (required or currentValue.length > 0): validationState[label] = "Bitte füllen Sie dieses Feld vollständig aus." else
				if currentValue.length > maxTextLength: validationState[label] = "Bitte geben Sie maximal {maxTextLength} Zeichen ein" else
				                                        validationState[label] = ""
			showErrorMessage validationState[label]

	// A number input field
	// Example:
	//     form.number label:"Price", model:price, unit:"€"
	number: string label = ""
		    Reference<float> model
		    Dimension width = 100%
		    string unit = ""
		    float minNumber = 0.0
		    float maxNumber = float.maxValue
		    void(float value) onChange = null
		    void(float value) onInput = null
		    bool required = false
		    string help = ""
		    ValidationState validationState = {}
		float currentValue = model
		
		column
			drawLabel label, required, help
			div display:flex, alignItems:center, gap:8, position:relative
				input width:width value:currentValue.isValidNumber ? currentValue.toString : ""
					borderRadius:8 border:{2px solid #d1d5db} padding:{12 16}
					outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
					fontSize:16, color:#2b3145
				onInput: value =>
					let floatValue = value.toFloat
					model = floatValue
					if onInput != null: onInput(floatValue)
				onBlur:
					if model: validationState.setShouldValidate(label)
					if onChange != null: onChange(model)
					refresh
				if unit != ""
					div text:unit, fontSize:16, color:#7a8195, position:absolute, right:16

			if validationState.shouldValidate(label)
				if !currentValue and currentValue != 0 and required: validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if currentValue < minNumber and (required or currentValue != 0): validationState[label] = "Der Wert muss mindestens {minNumber} betragen." else
				if currentValue > maxNumber: validationState[label] = "Der Wert muss maximal {maxNumber} betragen." else
				                             validationState[label] = ""
			showErrorMessage validationState[label]

	// A date input field (local date picker, stored as UTC TimeString)
	date: string label
		  Reference<string> model
		  Dimension width = 100%
		  void(string value) onChange = null
		  void(string value) onInput = null
		  bool required = false
		  string help = ""
		  ValidationState validationState = {}
		state string draftValue = ""
		state bool isEditing = false
		let currentValue = model or ""
		string localDateValue = ""
		string displayValue = draftValue
		if currentValue
			Date dt = Date(currentValue)
			localDateValue = "{dt.year}-{dt.twoDigitMonth}-{dt.twoDigitDay}"
			if not isEditing or draftValue == "": displayValue = "{dt.twoDigitDay}.{dt.twoDigitMonth}.{dt.year}"
		else
			if not isEditing: displayValue = ""
		
		column
			drawLabel label, required, help
			div position:relative, width
				input width:100%, value:displayValue
					borderRadius:8 border:{2px solid #d1d5db} padding:{12 40 12 16}
					outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
					fontSize:16, color:#2b3145
					data:{type:"text"}
				onInput: value =>
					isEditing = true
					if not value
						model = ""
						draftValue = ""
						if onInput != null: onInput(model)
						refresh
						return
					string[] parts = value.split(".")
					if parts.length == 3 and parts[0].length == 2 and parts[1].length == 2 and parts[2].length == 4
						int day = cast parts[0]
						int month = cast parts[1]
						int year = cast parts[2]
						Date dt = Date.fromValues year, month, day, 23, 59, 59
						model = "{dt.utcString}"
						draftValue = ""
					else
						draftValue = value
					if onInput != null: onInput(model)
					refresh
				onBlur:
					isEditing = false
					if model: validationState.setShouldValidate(label)
					if onChange != null: onChange(model)
					refresh

				let nativeInput = input width:28px, value:localDateValue
					position:absolute, right:8, top:8, height:28px, opacity:0
					pointerEvents:auto
					borderRadius:8, border:{2px solid transparent}
					data:{type:"date"}
				onInput: value =>
					if not value: return
					string[] parts = value.split("-")
					if parts.length == 3
						int year = cast parts[0]
						int month = cast parts[1]
						int day = cast parts[2]
						Date dt = Date.fromValues year, month, day, 23, 59, 59
						model = "{dt.utcString}"
						draftValue = ""
						if onInput != null: onInput(model)
						refresh

				div text:"📅", position:absolute, right:12, top:10, cursor:pointer, pointerEvents:none
					fontSize:18, color:#7a8195

			if validationState.shouldValidate(label)
				if not currentValue and required: validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				                                 validationState[label] = ""
			showErrorMessage validationState[label]

	// Renders a field with label and appropriate input
	// Example:
	//     form.drawField field, new Reference(container:good, key:field.fieldName)
	drawField: Field field
	           Reference<dynamic> model
	           void(dynamic value) onInput = null
	           void(dynamic value) onChange = null
	           ValidationState validationState = {}
		let label = field.description or field.name
		switch field.dataType
			SelectOne:
				let options = field.options.length > 0 ? field.options[0].values : []
				dropdown label, model, options
					allowCustomValues:field.allowCustomValues
					minTextLength:field.minTextLength ? field.minTextLength : 1
					maxTextLength:field.maxTextLength ? field.maxTextLength : 100
					required:field.required
					help:field.help
					validationState
					onInput: value => if onInput != null: onInput(value)
					onChange: value => if onChange != null: onChange(value)
			Toggle:
				toggle label, model, onInput: value => if onInput != null: onInput(value)
			Text:
				text label, model
					minTextLength:field.minTextLength ? field.minTextLength : 1
					maxTextLength:field.maxTextLength ? field.maxTextLength : 100
					rows:field.rows or 1
					required:field.required
					help:field.help
					validationState
					onInput: value => if onInput != null: onInput(value)
					onChange: value => if onChange != null: onChange(value)
			Number:
				number label, model, unit:field.unit
					minNumber:field.minNumber ? field.minNumber : int.minValue
					maxNumber:field.maxNumber ? field.maxNumber : int.maxValue
					required:field.required
					help:field.help
					validationState
					onInput: value => if onInput != null: onInput(value)
					onChange: value => if onChange != null: onChange(value)
			Date:
				date label, model
					required:field.required
					help:field.help
					validationState
					onInput: value => if onInput != null: onInput(value)
					onChange: value => if onChange != null: onChange(value)
			Images:
				drawLabel label, field.required, field.help
				string[] images = model.value or []
				row gap:12px flexWrap:wrap width:100% marginTop:12
					for images as image
						row alignItems:start
							if image.startsWith("data:")
								img src:image height:128 borderRadius:8
							else
								img "{backend.url}/api/files/goods/{editPage.good.id}/{image}?thumb=0x128" height:128px borderRadius:8
								img Remove margin:{left:-16 top:-8} width:24
									app.goods.removeFile model, image
					html.fileInput multiple:true
						div width:128px height:128px border:{2px solid primaryColor} borderRadius:8 display:flex flexDirection:column alignItems:center justifyContent:center gap:8
							img Add width:48px
							div "Bilder hochladen" fontSize:12 color:#6b7280
					onChange:
						html.closeDetails
						await app.goods.addFiles model, .files
							onError: alert delay:100, "Die folgenden Dateien konnten nicht hochgeladen werden:\n{.joinToString.name separator:"\n"}\n\nBitte prüfen Sie, ob die Dateien gültige JPEG oder PNG Bilder sind und versuchen Sie es nochmal. Falls das Problem erneut auftritt, könnte die Bilder in einem ungülten Format oder beschädigt sein. Wir empfehlen, die betroffenen Fotos erneut aufzunehmen. "
				if app.goods.busy
					row alignItems:center marginTop:8 gap:4
						img ProgressA, width:40
						div "Wird hochgeladen..."

	// Email input field
	email: string label
		   Reference<string> model
		   Dimension width = 100%
		   void(string value) onChange = null
		   void(string value) onInput = null
		   bool required = false
		   ValidationState validationState = {}
		   string help = ""
		   bool focusInitially = false
		   string autocomplete = "email"
		   string name = "email"
		let currentValue = model or ""
		
		column
			drawLabel label, required, help
			input width, value:currentValue, focusInitially
				borderRadius:8, border:{2px solid #d1d5db}
				outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				padding:{12 16}, fontSize:16, color:#2b3145
				data:{type:"email", autocomplete, name}
			onInput: value =>
				model = value
				if onInput != null: onInput(value)
				refresh
			onBlur:
				System.log "email: onBlur", ev.target, ev.currentTarget
				if model: validationState.setShouldValidate(label)
				if onChange != null: onChange(model)
				refresh

			if validationState.shouldValidate(label)
				if not currentValue and required:  validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if not currentValue.isEmail:       validationState[label] = "Bitte geben Sie eine gültige E-Mail-Adresse ein" else
				                                   validationState[label] = ""
			showErrorMessage validationState[label]

	// Password input field
	password: string label
		      Reference<string> model
		      Dimension width = 100%
		      int minTextLength = 1
		      int maxTextLength = 100
		      void(string value) onChange = null
		      void(string value) onInput = null
		      bool required = false
		      ValidationState validationState = {}
		      string help = ""
			  bool focusInitially = false
		      Reference<string> matchModel = null
		      string autocomplete = "current-password"
		      string name = "password"
		let currentValue = model or ""
		
		column
			drawLabel label, required, help
			input width, value:currentValue
				borderRadius:8, border:{2px solid #d1d5db}
				outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				padding:{12 16}, fontSize:16, color:#2b3145
				data:{type:"password", autocomplete, name}, focusInitially
			onInput: value =>
				model = value
				if onInput != null: onInput(value)
				refresh
			onBlur:
				if model: validationState.setShouldValidate(label)
				if onChange != null: onChange(model)
				refresh

			if validationState.shouldValidate(label)
				if not currentValue and required:  validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if matchModel != null and matchModel.value != currentValue: validationState[label] = "Passwörter stimmen nicht überein" else
				if currentValue.length < minTextLength: validationState[label] = "Ihr Passwort sollte mindestens {minTextLength} Zeichen lang sein" else
				if currentValue.length > maxTextLength: validationState[label] = "Ihr Passwort sollte maximal {maxTextLength} Zeichen lang sein" else
				                                        validationState[label] = ""
			showErrorMessage validationState[label]

	toggle: string label
		    Reference<bool> model
		    Dimension width = 100%
		    Image[] images = [ToggleOff, ToggleOn]
		    void(bool value) onInput = null
		    bool required = false
		    ValidationState validationState = {}
		    string help = ""
			string errorMessage = "Dieses Feld ist erforderlich."
		column
			row gap:12 alignItems:center, cursor:pointer
				let element = div tag:"img" height:24 marginTop:-3
				element.src = Platform.basePath + images[model ? 1 : 0].src
				drawLabel label, required, help
			onClick:
				model.assign not model
				validationState.setShouldValidate(label)
				if onInput != null: onInput(model)
				refresh
			if validationState.shouldValidate(label)
				let currentValue = model or false
				if not currentValue and required:	validationState[label] = errorMessage
				else	validationState[label] = ""
			showErrorMessage validationState[label]

	// Radio button group
	radioGroup: string label = ""
		        Reference<string> model
		        string[] options
		        string[] optionLabels = []
		        void(string value) onChange = null
		        bool required = false
		        string help = ""
		let labels = optionLabels.length > 0 ? optionLabels : options
		
		column
			drawLabel label, required, help
			div display:flex, gap:24
				for options as option, index
					let isSelected = (model or "") == option
					div display:flex, alignItems:center, gap:12, cursor:pointer
						onClick:
							model = option
							if onChange != null: onChange(option)
							refresh
						div width:20, height:20, borderRadius:10
							border:{width:2px, style:solid, color:isSelected ? primaryColor : #d1d5db}
							backgroundColor:isSelected ? primaryColor : white
							display:flex, alignItems:center, justifyContent:center
							if isSelected
								div width:10, height:10, borderRadius:5, backgroundColor:white
						div text:labels[index], fontSize:15, color:#40465a
